import type { FC } from 'react';
import { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import classNames from 'classnames';
import { ICollectOptionListItem } from '@/utils/ctype';
import { isSafari } from '@/utils/browser';
import HtmlParser from '../HtmlParser';
import style from './index.module.less';

export interface BoxProps {
	type: string;
  index: number;
  data: ICollectOptionListItem;
  optionClass?: string;
  display: boolean;
  optionHidden: string;
  uid: string;
  setShowDragFieldHandle: (val: boolean) => void;
}

const Box: FC<BoxProps> =function Box({ type, index, data, optionClass, display, optionHidden, uid, setShowDragFieldHandle }) {

  const {content} = data;

  const [, drag, preview] = useDrag(
    () => ({
      type,
      item: { data, type, index}, // 给出的数据
      collect(monitor){ 
        return {
          isDragging: monitor.isDragging(),
        };
      },
    }),
    [data, index, type],
  );

  useEffect(() => {
    if (!isSafari()) {
      preview(new Image(), { captureDraggingState: true }); // 隐藏拖拽dom
    }
  }, []);

  return (
    <div ref={drag} data-testid="box" data-exam-drag-option
      className={classNames(style.option, optionClass||'', 'canDrag', !display && style[optionHidden])} tabIndex={0} data-type={type} data-index={index} data-id={`${type}_${data.id}`} data-did={uid} data-disable>
      {data.title ? <span className={style.letter}><HtmlParser htmlString={data.titleHtml || data.title}></HtmlParser></span> : null}
      <HtmlParser htmlString={content}></HtmlParser>
    </div>
  );
};

export default Box;
